<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_x"></a><span class="bold">A Capital Question</span></h2>
<p class="noindent">Although common usage is to refer to ‘the Salvation Army’, this is not how it is known by its members. The trust deed which set up the organisation laid down that it was to be called ‘The Salvation Army’. The capitalisation of the definite article makes it part of the name so that in this way ‘Salvation’ may be seen to lay at its heart. This book will employ common usage.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Capital.vue?b5962068